export default [
	'bedc:dev:read',
	'bedc:dev:read/ui',

	'bedc:dev:list/acs',

	'bedc:dev:update/brand',
] as const;
